import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4d833398: FaireBrandEntity = {
  token: "b_4d833398",
  type: "brand",
  name: "Secret Aardvark Trading Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/d044111ad59f76623bd9c8b027032c72ddc6b5db8fff0c5862292df1947605dd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4641090369e80bafd22759f1d76d39b22dde58d3dadd42ee77c4e7ee5ea33de.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d044111ad59f76623bd9c8b027032c72ddc6b5db8fff0c5862292df1947605dd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4641090369e80bafd22759f1d76d39b22dde58d3dadd42ee77c4e7ee5ea33de.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 53,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Secret Aardvark Trading Co. was founded in 2004 by creative and culinary genius Scott Moritz. His love of travel, surfing, making music and telling stories was matched only by his passion for discovering the flavors of the world. We began hocking sauce at Portland farmer’s markets and now we’re in over 1,000 (and counting) roadhouses, eateries, and groceries from here to New York City, proudly gracing tables where the food matters, but the decor may not.\n\nScott’s life in food began when he entered a chili cook-off at age thirteen. He went on to start a pie company, several catering businesses, a tamale cart, and was a co-founder of Portland’s own Salvador Molly’s. Friends and family always coveted a spot at Scott’s table, where you never knew what delicious and unforgettable dishes (and tales) would emerge from the kitchen. His adventures ended far too soon when we lost him to pancreatic cancer in 2009. Scott’s passing left us to carry forward his dream of sharing his unique, flavorful, and affordable sauces with the world. And we are proud to do so.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T06:31:32.588Z",
    importedBy: "entity-db-cli",
  },
};
